import axios from 'axios';
import api from '../services/api';

export interface IEnderecoCep {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
}

// ViaCEP: CEP inexistente volta 200 com { erro: true }
export async function buscarCep(cep: string): Promise<IEnderecoCep | null> {
  const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`, { timeout: 10000 });
  if (!response.data || response.data.erro) return null;
  return response.data;
}

// Cidade do cadastro com o codibg do ViaCEP. Pesquisa pelo nome (no banco fica em maiúsculas e sem acento)
// e confere o codibg; o apóstrofo vira '%' porque a API monta o like por concatenação (ex.: D'OESTE)
export async function buscarCidadePorIbge(nome: string, ibge: string): Promise<Record<string, any> | undefined> {
  const pesquisa = nome.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/'/g, '%').toUpperCase();
  const mesmoIbge = (cidade: any) => String(cidade?.codibg) === String(ibge);

  const porNome = await api.get('/cidade', { params: { pesquisa, per_page: 100 } });
  const cidade = (porNome.data?.data ?? []).find(mesmoIbge);
  if (cidade) return cidade;

  // Nome diferente no cadastro: filtro direto pela coluna (GET genérico: codibg in (...))
  const porIbge = await api.get('/cidade', { params: { codibg: ibge } });
  return (porIbge.data?.data ?? []).find(mesmoIbge);
}
